// Utility to get state boundary coordinates for highlighting on map
// These are more accurate polygon boundaries that better represent actual state shapes
export const STATE_BOUNDARY_COORDS = {
  'Alabama': [
    { lat: 35.0, lng: -88.1 }, { lat: 35.0, lng: -86.3 }, { lat: 34.0, lng: -85.0 },
    { lat: 31.0, lng: -85.0 }, { lat: 30.2, lng: -87.6 }, { lat: 30.3, lng: -88.4 },
    { lat: 31.0, lng: -88.2 }, { lat: 32.0, lng: -88.3 }, { lat: 33.0, lng: -88.3 },
    { lat: 35.0, lng: -88.1 }
  ],
  'Alaska': [
    { lat: 55.2, lng: -131.0 }, { lat: 55.0, lng: -130.0 }, { lat: 54.8, lng: -130.8 },
    { lat: 55.9, lng: -134.8 }, { lat: 58.3, lng: -137.2 }, { lat: 59.5, lng: -139.0 },
    { lat: 60.3, lng: -141.0 }, { lat: 60.2, lng: -144.0 }, { lat: 61.2, lng: -146.0 },
    { lat: 60.0, lng: -153.0 }, { lat: 58.0, lng: -157.0 }, { lat: 55.0, lng: -165.0 },
    { lat: 54.5, lng: -168.0 }, { lat: 57.0, lng: -170.0 }, { lat: 60.0, lng: -168.0 },
    { lat: 65.8, lng: -168.0 }, { lat: 70.0, lng: -162.0 }, { lat: 71.4, lng: -156.0 },
    { lat: 69.8, lng: -141.0 }, { lat: 65.0, lng: -141.0 }, { lat: 60.3, lng: -141.0 }
  ],
  'Arizona': [
    { lat: 37.0, lng: -114.0 }, { lat: 37.0, lng: -111.0 }, { lat: 36.0, lng: -109.0 },
    { lat: 31.3, lng: -109.0 }, { lat: 31.3, lng: -111.0 }, { lat: 32.0, lng: -112.5 },
    { lat: 32.5, lng: -114.8 }, { lat: 34.0, lng: -114.5 }, { lat: 35.5, lng: -114.6 },
    { lat: 37.0, lng: -114.0 }
  ],
  'Arkansas': [
    { lat: 36.5, lng: -94.6 }, { lat: 36.5, lng: -92.0 }, { lat: 36.3, lng: -90.0 },
    { lat: 36.0, lng: -89.6 }, { lat: 34.5, lng: -90.5 }, { lat: 33.0, lng: -91.1 },
    { lat: 33.0, lng: -92.5 }, { lat: 33.2, lng: -94.0 }, { lat: 33.4, lng: -94.4 },
    { lat: 35.0, lng: -94.6 }, { lat: 36.5, lng: -94.6 }
  ],
'California': [
    { lat: 42.00, lng: -124.40 }, { lat: 42.00, lng: -120.00 }, 
    { lat: 39.00, lng: -120.00 }, { lat: 35.10, lng: -114.60 },
    { lat: 34.20, lng: -114.13 }, { lat: 32.72, lng: -114.48 },
    { lat: 32.53, lng: -117.12 }, { lat: 33.74, lng: -118.40 },
    { lat: 34.45, lng: -120.45 }, { lat: 36.58, lng: -121.95 }, 
    { lat: 37.80, lng: -122.50 }, { lat: 38.30, lng: -123.07 }, 
    { lat: 39.75, lng: -123.80 }, { lat: 40.44, lng: -124.41 },
    { lat: 41.78, lng: -124.22 }, { lat: 42.00, lng: -124.40 }  
],
  'Colorado': [
    { lat: 41.0, lng: -109.0 }, { lat: 41.0, lng: -105.5 }, { lat: 41.0, lng: -102.0 },
    { lat: 39.0, lng: -102.0 }, { lat: 37.0, lng: -102.0 }, { lat: 37.0, lng: -105.5 },
    { lat: 37.0, lng: -109.0 }, { lat: 39.0, lng: -109.0 }, { lat: 41.0, lng: -109.0 }
  ],
  'Connecticut': [
    { lat: 42.0, lng: -73.5 }, { lat: 42.0, lng: -72.5 }, { lat: 42.0, lng: -71.8 },
    { lat: 41.2, lng: -71.8 }, { lat: 41.5, lng: -72.3 }, { lat: 41.0, lng: -72.8 },
    { lat: 41.0, lng: -73.5 }, { lat: 41.5, lng: -73.5 }, { lat: 42.0, lng: -73.5 }
  ],
  'Delaware': [
    { lat: 39.8, lng: -75.8 }, { lat: 39.8, lng: -75.6 }, { lat: 39.7, lng: -75.4 },
    { lat: 39.0, lng: -75.1 }, { lat: 38.4, lng: -75.0 }, { lat: 38.4, lng: -75.4 },
    { lat: 38.4, lng: -75.8 }, { lat: 39.2, lng: -75.8 }, { lat: 39.8, lng: -75.8 }
  ],
  'Florida': [
    { lat: 31.0, lng: -87.6 }, { lat: 31.0, lng: -86.0 }, { lat: 30.8, lng: -85.0 },
    { lat: 30.7, lng: -83.0 }, { lat: 30.7, lng: -81.7 }, { lat: 30.5, lng: -81.4 },
    { lat: 28.0, lng: -80.5 }, { lat: 25.0, lng: -80.3 }, { lat: 24.5, lng: -81.8 },
    { lat: 25.5, lng: -81.2 }, { lat: 26.0, lng: -81.8 }, { lat: 28.0, lng: -82.8 },
    { lat: 30.0, lng: -84.1 }, { lat: 29.2, lng: -85.4 }, { lat: 30.2, lng: -87.6 }
  ],
  'Georgia': [
    { lat: 35.0, lng: -85.6 }, { lat: 35.0, lng: -84.0 }, { lat: 34.5, lng: -83.0 },
    { lat: 34.0, lng: -82.8 }, { lat: 32.0, lng: -81.0 }, { lat: 30.7, lng: -81.5 },
    { lat: 30.7, lng: -82.0 }, { lat: 31.0, lng: -83.5 }, { lat: 31.0, lng: -85.0 },
    { lat: 33.0, lng: -85.2 }, { lat: 35.0, lng: -85.6 }
  ],
  'Hawaii': [
    { lat: 22.2, lng: -159.8 }, { lat: 22.0, lng: -159.3 }, { lat: 21.5, lng: -158.3 },
    { lat: 21.3, lng: -157.7 }, { lat: 21.0, lng: -157.0 }, { lat: 20.9, lng: -156.4 },
    { lat: 19.5, lng: -154.8 }, { lat: 18.9, lng: -155.6 }, { lat: 19.3, lng: -156.0 },
    { lat: 20.0, lng: -156.0 }, { lat: 21.6, lng: -158.3 }
  ],
  'Idaho': [
    { lat: 49.0, lng: -117.0 }, { lat: 49.0, lng: -116.0 }, { lat: 47.0, lng: -116.0 },
    { lat: 44.5, lng: -111.0 }, { lat: 43.0, lng: -111.0 }, { lat: 42.0, lng: -111.0 },
    { lat: 42.0, lng: -114.0 }, { lat: 42.0, lng: -117.0 }, { lat: 43.5, lng: -117.0 },
    { lat: 45.0, lng: -117.0 }, { lat: 47.0, lng: -117.0 }, { lat: 49.0, lng: -117.0 }
  ],
  'Illinois': [
    { lat: 42.5, lng: -90.1 }, { lat: 42.5, lng: -88.5 }, { lat: 42.5, lng: -87.5 },
    { lat: 41.0, lng: -87.5 }, { lat: 39.0, lng: -87.5 }, { lat: 37.5, lng: -88.0 },
    { lat: 37.0, lng: -88.0 }, { lat: 37.0, lng: -89.5 }, { lat: 38.0, lng: -90.5 },
    { lat: 39.0, lng: -91.5 }, { lat: 40.5, lng: -91.5 }, { lat: 41.5, lng: -91.0 },
    { lat: 42.5, lng: -90.1 }
  ],
  'Indiana': [
    { lat: 41.7, lng: -87.5 }, { lat: 41.7, lng: -86.0 }, { lat: 41.7, lng: -84.8 },
    { lat: 40.0, lng: -84.8 }, { lat: 39.1, lng: -84.8 }, { lat: 38.2, lng: -86.5 },
    { lat: 37.8, lng: -88.0 }, { lat: 38.5, lng: -87.5 }, { lat: 40.0, lng: -87.5 },
    { lat: 41.7, lng: -87.5 }
  ],
  'Iowa': [
    { lat: 43.5, lng: -96.6 }, { lat: 43.5, lng: -94.0 }, { lat: 43.5, lng: -91.0 },
    { lat: 42.5, lng: -90.1 }, { lat: 41.5, lng: -91.0 }, { lat: 40.6, lng: -91.7 },
    { lat: 40.6, lng: -93.5 }, { lat: 40.6, lng: -95.8 }, { lat: 41.5, lng: -96.0 },
    { lat: 42.7, lng: -96.5 }, { lat: 43.5, lng: -96.6 }
  ],
  'Kansas': [
    { lat: 40.0, lng: -102.0 }, { lat: 40.0, lng: -98.0 }, { lat: 40.0, lng: -94.6 },
    { lat: 38.5, lng: -94.6 }, { lat: 37.0, lng: -94.6 }, { lat: 37.0, lng: -98.0 },
    { lat: 37.0, lng: -102.0 }, { lat: 38.5, lng: -102.0 }, { lat: 40.0, lng: -102.0 }
  ],
  'Kentucky': [
    { lat: 39.1, lng: -84.8 }, { lat: 39.1, lng: -82.9 }, { lat: 38.5, lng: -82.5 },
    { lat: 37.5, lng: -82.0 }, { lat: 36.6, lng: -81.9 }, { lat: 36.6, lng: -85.0 },
    { lat: 36.6, lng: -88.0 }, { lat: 36.5, lng: -89.4 }, { lat: 37.2, lng: -89.0 },
    { lat: 37.8, lng: -88.0 }, { lat: 38.5, lng: -86.0 }, { lat: 39.1, lng: -84.8 }
  ],
  'Louisiana': [
    { lat: 33.0, lng: -94.0 }, { lat: 33.0, lng: -92.5 }, { lat: 33.0, lng: -91.1 },
    { lat: 31.0, lng: -89.5 }, { lat: 30.0, lng: -89.5 }, { lat: 29.0, lng: -89.0 },
    { lat: 29.2, lng: -91.5 }, { lat: 29.5, lng: -93.6 }, { lat: 31.0, lng: -93.8 },
    { lat: 33.0, lng: -94.0 }
  ],
  'Maine': [
    { lat: 47.4, lng: -69.2 }, { lat: 47.2, lng: -67.8 }, { lat: 46.0, lng: -67.8 },
    { lat: 45.4, lng: -67.1 }, { lat: 44.8, lng: -66.9 }, { lat: 44.0, lng: -68.5 },
    { lat: 43.1, lng: -70.6 }, { lat: 44.0, lng: -71.0 }, { lat: 45.2, lng: -71.1 },
    { lat: 46.0, lng: -70.0 }, { lat: 47.4, lng: -69.2 }
  ],
  'Maryland': [
    { lat: 39.7, lng: -79.5 }, { lat: 39.7, lng: -77.5 }, { lat: 39.7, lng: -75.8 },
    { lat: 38.4, lng: -75.0 }, { lat: 38.0, lng: -75.2 }, { lat: 38.3, lng: -76.3 },
    { lat: 38.0, lng: -76.5 }, { lat: 39.2, lng: -76.1 }, { lat: 38.0, lng: -77.0 },
    { lat: 38.5, lng: -78.5 }, { lat: 39.7, lng: -79.5 }
  ],
  'Massachusetts': [
    { lat: 42.8, lng: -73.5 }, { lat: 42.8, lng: -71.5 }, { lat: 42.8, lng: -70.8 },
    { lat: 42.0, lng: -70.0 }, { lat: 41.7, lng: -70.0 }, { lat: 41.5, lng: -70.2 },
    { lat: 41.2, lng: -71.8 }, { lat: 42.0, lng: -71.8 }, { lat: 42.0, lng: -72.5 },
    { lat: 42.0, lng: -73.5 }, { lat: 42.8, lng: -73.5 }
  ],
  'Michigan': [
    { lat: 48.2, lng: -88.5 }, { lat: 47.5, lng: -87.8 }, { lat: 46.5, lng: -85.0 },
    { lat: 45.5, lng: -83.5 }, { lat: 44.2, lng: -82.7 }, { lat: 42.5, lng: -82.5 },
    { lat: 41.7, lng: -82.5 }, { lat: 41.7, lng: -84.8 }, { lat: 41.7, lng: -86.5 },
    { lat: 42.7, lng: -86.2 }, { lat: 44.0, lng: -86.5 }, { lat: 45.0, lng: -87.3 },
    { lat: 45.8, lng: -89.2 }, { lat: 46.5, lng: -89.0 }, { lat: 48.2, lng: -88.5 }
  ],
  'Minnesota': [
    { lat: 49.3, lng: -97.2 }, { lat: 49.2, lng: -95.1 }, { lat: 49.0, lng: -95.1 },
    { lat: 48.0, lng: -89.5 }, { lat: 47.5, lng: -90.5 }, { lat: 46.5, lng: -92.1 },
    { lat: 45.0, lng: -92.5 }, { lat: 43.5, lng: -91.2 }, { lat: 43.5, lng: -94.0 },
    { lat: 43.5, lng: -96.6 }, { lat: 46.0, lng: -96.8 }, { lat: 49.3, lng: -97.2 }
  ],
  'Mississippi': [
    { lat: 35.0, lng: -90.0 }, { lat: 35.0, lng: -89.0 }, { lat: 35.0, lng: -88.1 },
    { lat: 33.0, lng: -88.2 }, { lat: 31.0, lng: -88.2 }, { lat: 30.2, lng: -88.4 },
    { lat: 30.3, lng: -89.5 }, { lat: 31.0, lng: -90.5 }, { lat: 32.5, lng: -91.2 },
    { lat: 34.0, lng: -90.8 }, { lat: 35.0, lng: -90.0 }
  ],
  'Missouri': [
    { lat: 40.6, lng: -95.8 }, { lat: 40.6, lng: -93.5 }, { lat: 40.6, lng: -91.7 },
    { lat: 39.0, lng: -89.1 }, { lat: 37.5, lng: -89.2 }, { lat: 36.5, lng: -89.4 },
    { lat: 36.5, lng: -90.0 }, { lat: 36.0, lng: -89.6 }, { lat: 36.0, lng: -92.5 },
    { lat: 36.0, lng: -94.6 }, { lat: 37.0, lng: -94.6 }, { lat: 39.0, lng: -94.6 },
    { lat: 40.6, lng: -95.8 }
  ],
  'Montana': [
    { lat: 49.0, lng: -116.0 }, { lat: 49.0, lng: -110.0 }, { lat: 49.0, lng: -104.0 },
    { lat: 47.0, lng: -104.0 }, { lat: 45.0, lng: -104.0 }, { lat: 45.0, lng: -108.0 },
    { lat: 44.5, lng: -111.0 }, { lat: 45.5, lng: -113.0 }, { lat: 47.0, lng: -115.0 },
    { lat: 49.0, lng: -116.0 }
  ],
  'Nebraska': [
    { lat: 43.0, lng: -104.0 }, { lat: 43.0, lng: -100.0 }, { lat: 43.0, lng: -97.2 },
    { lat: 42.7, lng: -96.5 }, { lat: 41.5, lng: -95.8 }, { lat: 40.0, lng: -95.3 },
    { lat: 40.0, lng: -98.0 }, { lat: 40.0, lng: -102.0 }, { lat: 41.0, lng: -104.0 },
    { lat: 42.0, lng: -104.0 }, { lat: 43.0, lng: -104.0 }
  ],
  'Nevada': [
    { lat: 42.0, lng: -120.0 }, { lat: 42.0, lng: -118.0 }, { lat: 42.0, lng: -117.0 },
    { lat: 41.0, lng: -114.0 }, { lat: 39.0, lng: -114.0 }, { lat: 37.0, lng: -114.0 },
    { lat: 35.0, lng: -114.6 }, { lat: 36.0, lng: -117.0 }, { lat: 39.0, lng: -120.0 },
    { lat: 40.5, lng: -120.0 }, { lat: 42.0, lng: -120.0 }
  ],
  'New Hampshire': [
    { lat: 45.3, lng: -71.5 }, { lat: 45.2, lng: -71.1 }, { lat: 44.0, lng: -71.0 },
    { lat: 42.8, lng: -70.8 }, { lat: 42.7, lng: -71.6 }, { lat: 42.8, lng: -72.5 },
    { lat: 43.5, lng: -72.5 }, { lat: 44.5, lng: -71.8 }, { lat: 45.3, lng: -71.5 }
  ],
  'New Jersey': [
    { lat: 41.3, lng: -74.7 }, { lat: 41.3, lng: -74.0 }, { lat: 40.6, lng: -74.0 },
    { lat: 40.0, lng: -74.0 }, { lat: 39.0, lng: -74.0 }, { lat: 39.0, lng: -74.8 },
    { lat: 39.5, lng: -75.2 }, { lat: 39.7, lng: -75.4 }, { lat: 40.5, lng: -75.0 },
    { lat: 41.3, lng: -74.7 }
  ],
  'New Mexico': [
    { lat: 37.0, lng: -109.0 }, { lat: 37.0, lng: -106.0 }, { lat: 37.0, lng: -103.0 },
    { lat: 34.5, lng: -103.0 }, { lat: 32.0, lng: -103.0 }, { lat: 32.0, lng: -106.0 },
    { lat: 32.0, lng: -109.0 }, { lat: 34.5, lng: -109.0 }, { lat: 37.0, lng: -109.0 }
  ],
  'New York': [
    { lat: 45.0, lng: -74.8 }, { lat: 45.0, lng: -73.3 }, { lat: 42.8, lng: -73.3 },
    { lat: 41.0, lng: -72.0 }, { lat: 40.6, lng: -73.5 }, { lat: 40.6, lng: -74.0 },
    { lat: 41.3, lng: -74.7 }, { lat: 42.0, lng: -76.0 }, { lat: 42.0, lng: -79.8 },
    { lat: 42.8, lng: -79.0 }, { lat: 43.5, lng: -78.2 }, { lat: 44.0, lng: -76.0 },
    { lat: 45.0, lng: -74.8 }
  ],
  'North Carolina': [
    { lat: 36.5, lng: -81.7 }, { lat: 36.5, lng: -78.0 }, { lat: 36.5, lng: -75.7 },
    { lat: 35.5, lng: -75.5 }, { lat: 35.0, lng: -75.5 }, { lat: 34.2, lng: -77.8 },
    { lat: 33.8, lng: -78.5 }, { lat: 34.0, lng: -80.0 }, { lat: 34.5, lng: -82.0 },
    { lat: 35.0, lng: -84.3 }, { lat: 36.0, lng: -83.0 }, { lat: 36.5, lng: -81.7 }
  ],
  'North Dakota': [
    { lat: 49.0, lng: -104.0 }, { lat: 49.0, lng: -100.0 }, { lat: 49.0, lng: -97.2 },
    { lat: 47.5, lng: -97.0 }, { lat: 46.0, lng: -96.5 }, { lat: 46.0, lng: -100.0 },
    { lat: 46.0, lng: -104.0 }, { lat: 47.5, lng: -104.0 }, { lat: 49.0, lng: -104.0 }
  ],
  'Ohio': [
    { lat: 41.7, lng: -84.8 }, { lat: 42.0, lng: -82.5 }, { lat: 41.8, lng: -81.5 },
    { lat: 41.5, lng: -80.5 }, { lat: 40.0, lng: -80.5 }, { lat: 39.0, lng: -80.5 },
    { lat: 38.4, lng: -82.4 }, { lat: 38.6, lng: -83.5 }, { lat: 39.1, lng: -84.8 },
    { lat: 40.5, lng: -84.8 }, { lat: 41.7, lng: -84.8 }
  ],
  'Oklahoma': [
    { lat: 37.0, lng: -103.0 }, { lat: 37.0, lng: -98.0 }, { lat: 37.0, lng: -94.6 },
    { lat: 36.5, lng: -94.6 }, { lat: 35.0, lng: -94.5 }, { lat: 33.6, lng: -94.4 },
    { lat: 34.0, lng: -97.0 }, { lat: 34.0, lng: -100.0 }, { lat: 35.5, lng: -100.0 },
    { lat: 36.5, lng: -100.0 }, { lat: 37.0, lng: -103.0 }
  ],
  'Oregon': [
    { lat: 46.2, lng: -124.1 }, { lat: 46.2, lng: -120.0 }, { lat: 46.2, lng: -116.9 },
    { lat: 45.5, lng: -116.9 }, { lat: 44.0, lng: -117.0 }, { lat: 42.0, lng: -117.0 },
    { lat: 42.0, lng: -120.0 }, { lat: 42.0, lng: -124.2 }, { lat: 44.0, lng: -124.2 },
    { lat: 46.2, lng: -124.1 }
  ],
  'Pennsylvania': [
    { lat: 42.0, lng: -79.8 }, { lat: 42.3, lng: -79.8 }, { lat: 42.0, lng: -77.0 },
    { lat: 42.0, lng: -75.0 }, { lat: 41.0, lng: -75.0 }, { lat: 39.7, lng: -75.0 },
    { lat: 39.7, lng: -77.5 }, { lat: 39.7, lng: -80.5 }, { lat: 40.5, lng: -80.5 },
    { lat: 41.5, lng: -80.5 }, { lat: 42.0, lng: -79.8 }
  ],
  'Rhode Island': [
    { lat: 42.0, lng: -71.8 }, { lat: 42.0, lng: -71.4 }, { lat: 42.0, lng: -71.1 },
    { lat: 41.7, lng: -71.1 }, { lat: 41.5, lng: -71.2 }, { lat: 41.4, lng: -71.4 },
    { lat: 41.2, lng: -71.8 }, { lat: 41.8, lng: -71.8 }, { lat: 42.0, lng: -71.8 }
  ],
  'South Carolina': [
    { lat: 35.2, lng: -82.8 }, { lat: 35.1, lng: -81.0 }, { lat: 35.1, lng: -80.0 },
    { lat: 34.5, lng: -79.0 }, { lat: 33.8, lng: -78.5 }, { lat: 33.0, lng: -79.2 },
    { lat: 32.0, lng: -80.8 }, { lat: 32.5, lng: -81.5 }, { lat: 33.0, lng: -82.4 },
    { lat: 34.0, lng: -82.8 }, { lat: 35.2, lng: -82.8 }
  ],
  'South Dakota': [
    { lat: 46.0, lng: -104.0 }, { lat: 46.0, lng: -100.0 }, { lat: 46.0, lng: -96.5 },
    { lat: 44.5, lng: -96.5 }, { lat: 43.0, lng: -96.5 }, { lat: 43.0, lng: -100.0 },
    { lat: 43.0, lng: -104.0 }, { lat: 44.5, lng: -104.0 }, { lat: 46.0, lng: -104.0 }
  ],
  'Tennessee': [
    { lat: 36.6, lng: -88.0 }, { lat: 36.6, lng: -85.0 }, { lat: 36.6, lng: -81.9 },
    { lat: 35.5, lng: -82.0 }, { lat: 35.0, lng: -82.0 }, { lat: 35.0, lng: -85.0 },
    { lat: 35.0, lng: -88.0 }, { lat: 35.0, lng: -90.0 }, { lat: 35.8, lng: -89.5 },
    { lat: 36.6, lng: -88.0 }
  ],
  'Texas': [
    { lat: 36.5, lng: -103.0 }, { lat: 36.5, lng: -100.0 }, { lat: 34.0, lng: -100.0 },
    { lat: 34.0, lng: -97.0 }, { lat: 33.6, lng: -94.4 }, { lat: 32.0, lng: -94.2 },
    { lat: 29.5, lng: -93.8 }, { lat: 28.0, lng: -97.0 }, { lat: 26.0, lng: -97.2 },
    { lat: 25.8, lng: -100.0 }, { lat: 28.0, lng: -102.0 }, { lat: 29.0, lng: -104.0 },
    { lat: 32.0, lng: -106.6 }, { lat: 34.0, lng: -104.0 }, { lat: 36.5, lng: -103.0 }
  ],
  'Utah': [
    { lat: 42.0, lng: -114.0 }, { lat: 42.0, lng: -112.5 }, { lat: 42.0, lng: -111.0 },
    { lat: 41.0, lng: -109.0 }, { lat: 39.0, lng: -109.0 }, { lat: 37.0, lng: -109.0 },
    { lat: 37.0, lng: -111.0 }, { lat: 37.0, lng: -114.0 }, { lat: 39.5, lng: -114.0 },
    { lat: 42.0, lng: -114.0 }
  ],
  'Vermont': [
    { lat: 45.0, lng: -73.3 }, { lat: 45.0, lng: -72.5 }, { lat: 45.0, lng: -71.5 },
    { lat: 44.0, lng: -71.5 }, { lat: 42.8, lng: -72.5 }, { lat: 42.8, lng: -73.3 },
    { lat: 43.5, lng: -73.3 }, { lat: 44.5, lng: -73.3 }, { lat: 45.0, lng: -73.3 }
  ],
  'Virginia': [
    { lat: 39.2, lng: -78.0 }, { lat: 38.3, lng: -76.3 }, { lat: 38.0, lng: -75.2 },
    { lat: 37.2, lng: -75.9 }, { lat: 36.5, lng: -75.7 }, { lat: 36.5, lng: -80.0 },
    { lat: 36.5, lng: -83.7 }, { lat: 37.0, lng: -82.0 }, { lat: 37.5, lng: -82.5 },
    { lat: 38.0, lng: -82.0 }, { lat: 38.5, lng: -80.0 }, { lat: 39.5, lng: -79.5 },
    { lat: 39.2, lng: -78.0 }
  ],
  'Washington': [
    { lat: 49.0, lng: -123.0 }, { lat: 49.0, lng: -120.0 }, { lat: 49.0, lng: -117.0 },
    { lat: 47.5, lng: -117.0 }, { lat: 46.0, lng: -117.0 }, { lat: 46.0, lng: -119.0 },
    { lat: 46.2, lng: -124.1 }, { lat: 47.5, lng: -124.5 }, { lat: 48.3, lng: -124.7 },
    { lat: 48.5, lng: -123.0 }, { lat: 49.0, lng: -123.0 }
  ],
  'West Virginia': [
    { lat: 39.7, lng: -80.5 }, { lat: 40.6, lng: -80.6 }, { lat: 39.5, lng: -79.5 },
    { lat: 39.2, lng: -78.0 }, { lat: 38.5, lng: -78.0 }, { lat: 38.0, lng: -77.0 },
    { lat: 37.5, lng: -80.5 }, { lat: 37.2, lng: -81.0 }, { lat: 37.8, lng: -82.0 },
    { lat: 38.4, lng: -82.6 }, { lat: 39.0, lng: -81.5 }, { lat: 39.0, lng: -80.5 }
  ],
  'Wisconsin': [
    { lat: 46.8, lng: -92.1 }, { lat: 47.0, lng: -90.5 }, { lat: 46.0, lng: -88.0 },
    { lat: 45.5, lng: -87.0 }, { lat: 44.0, lng: -87.5 }, { lat: 42.5, lng: -87.8 },
    { lat: 42.5, lng: -89.0 }, { lat: 42.5, lng: -90.1 }, { lat: 43.5, lng: -91.2 },
    { lat: 45.0, lng: -91.5 }, { lat: 46.5, lng: -92.1 }
  ],
  'Wyoming': [
    { lat: 45.0, lng: -111.1 }, { lat: 45.0, lng: -107.5 }, { lat: 45.0, lng: -104.1 },
    { lat: 43.0, lng: -104.1 }, { lat: 41.0, lng: -104.1 }, { lat: 41.0, lng: -107.5 },
    { lat: 41.0, lng: -111.1 }, { lat: 43.0, lng: -111.1 }, { lat: 45.0, lng: -111.1 }
  ]
};

export function getStateBoundaryCoords(stateName) {
  return STATE_BOUNDARY_COORDS[stateName] || null;
}

export function getAllStateNames() {
  return Object.keys(STATE_BOUNDARY_COORDS);
}